const isTurkeyDestAndUser = () => {
    var _a, _b, _c, _d, _e;
    return ((_b = (_a = window.shared) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.country_code) === 'TR' &&
        ((_e = (_d = (_c = window.shared) === null || _c === void 0 ? void 0 : _c.options) === null || _d === void 0 ? void 0 : _d.user) === null || _e === void 0 ? void 0 : _e.country_code) === 'TR';
};
export default isTurkeyDestAndUser;
